import { Map, fromJS } from 'immutable';

export function request(state) {
    return state
        .setIn(['master-ladder', 'state'], 'IN_PROGRESS')
}

export function error(state, {errors}) {
    return state
        .setIn(['master-ladder', 'state'], 'ERROR')
        .setIn(['master-ladder', 'errors'], fromJS(errors));
}

export function finish(state, {prices}) {
    prices = Map(fromJS({prices}));
    return state
        .set('master-ladder', prices)
        .setIn(['master-ladder', 'state'], 'FINISHED')
}
